import { useRouter } from '@tanstack/react-router';
import { P } from '@vagusx/shared';
import { useHasPermission } from '@/hooks/use-permissions';
import { ContactPolicyEditor } from './ContactPolicyEditor';

/**
 * The organization's contact rules (ADR-318, G/H), as a page of its own:
 * readable with outreach:view, changeable with outreach:edit. Leaving goes
 * back to wherever the author came from.
 */
export function ContactRulesPage(): React.ReactElement {
  const router = useRouter();
  const canEdit = useHasPermission(P.OUTREACH_EDIT);
  return <ContactPolicyEditor onClose={() => router.history.back()} readOnly={!canEdit} />;
}
